var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-pre-loader"},[_c('img',{attrs:{"src":require("../../../assets/fractel/spinner.svg")}}),_vm._v(" "),(_vm.total > 0)?_c('p',{staticClass:"vuestic-pre-loader loader-text text-center"},[_vm._v(_vm._s(_vm.current)+" of "+_vm._s(_vm.total)+" completed")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81ab43ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vuestic-theme/vuestic-components/vuestic-preloader/VuesticPreLoader.vue
// module id = 9Xop
// module chunks = 212